"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var FinanceQuotePrices_1 = require("../../../../../prices/finance/FinanceQuotePrices");
var noComparisonFinanceRatesBlockStyles_1 = require("./noComparisonFinanceRatesBlockStyles");
var LabelAfter_1 = require("../../../StaticContent/LabelAfter");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var ShowIfTranslationExists_1 = require("../../../../../../../common/components/ShowIfTranslationExists");
var NoComparisonFinanceRatesBlock = function (_a) {
    var financeDetails = _a.financeDetails, totalPayable = _a.totalPayable;
    var _b;
    var style = noComparisonFinanceRatesBlockStyles_1.default();
    return (<core_1.Grid container={true}>
      <core_1.Grid item={true} xs={12}>
        <ShowIfTranslationExists_1.default translationKey="financeSummary.label.referentialFinance">
          <core_1.Typography variant="h3" component="div" className={style.referentialFinancial}>
            <Translation_1.default id="financeSummary.label.referentialFinance"/>
          </core_1.Typography>
        </ShowIfTranslationExists_1.default>
      </core_1.Grid>
      <core_1.Grid item={true} xs={12}>
        <FinanceQuotePrices_1.default primaryPrice={(_b = financeDetails) === null || _b === void 0 ? void 0 : _b.primary} isMultiCurrency={false} className={style.financeQuotePrice} dataTest="finance_summary:container:primary_quote" labelAfter={<LabelAfter_1.default className={style.labelAfter} financeDetails={financeDetails}/>}/>
        <core_1.Typography variant="caption" component="div" className={style.repaymentLabel}>
          <Translation_1.default id={'financeSummary.label.estimateRepayment'} values={{ total: totalPayable }}/>
        </core_1.Typography>
      </core_1.Grid>
    </core_1.Grid>);
};
exports.default = NoComparisonFinanceRatesBlock;
